import { TaskRef } from '@/tracker/types';

/** «TIME-12 Название» — подпись задачи в выборе */
export const getTaskLabel = (task: TaskRef): string => `${task.key} ${task.summary}`;
